/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { feedsShow } from '../../axios/feedsShow'
import type { FeedsShowError, FeedsShowPathParams, FeedsShowResponse } from '../../types/FeedsShow'

export const feedsShowQueryKey = (feed: FeedsShowPathParams['feed']) =>
	[{ url: '/ad-generation/feeds/:feed', params: { feed } }] as const

export type FeedsShowQueryKey = ReturnType<typeof feedsShowQueryKey>

/** @see backend/nexus/modules/AdGeneration/Http/Controllers/FeedController.php FeedController::show */
export function feedsShowQueryOptions(feed: FeedsShowPathParams['feed'], config?: AxiosRequestConfig) {
	return queryOptions<FeedsShowResponse, AxiosError<FeedsShowError>, FeedsShowResponse, FeedsShowQueryKey>({
		queryKey: feedsShowQueryKey(feed),
		queryFn: ({ signal }) => feedsShow(feed, { signal, ...config }).then(res => res.data),
		enabled: !!feed,
	})
}

/** @see backend/nexus/modules/AdGeneration/Http/Controllers/FeedController.php FeedController::show */
export function useFeedsShow<TSelectData = FeedsShowResponse>(
	feed: FeedsShowPathParams['feed'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<FeedsShowResponse, AxiosError<FeedsShowError>, TSelectData, FeedsShowQueryKey>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<FeedsShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...feedsShowQueryOptions(feed),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/AdGeneration/Http/Controllers/FeedController.php FeedController::show */
export function useFeedsShowSuspense<TSelectData = FeedsShowResponse>(
	feed: FeedsShowPathParams['feed'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<FeedsShowResponse, AxiosError<FeedsShowError>, TSelectData, FeedsShowQueryKey>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<FeedsShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...feedsShowQueryOptions(feed),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
